export default __webpack_public_path__ + "static/media/logo_mobile.9affd545.svg";